import { Component, OnInit } from '@angular/core';
import {
	BusinessMatterClient,
	BusinessMatterClientWithAssociations,
	MatterClientType,
	MatterFileType,
	PersonMatterClient,
	PersonMatterClientWithAssociations,
} from '@models/matter';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterClients } from '@state/global/matter_clients';
import { ICON } from '@core/util/icon';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterDispatch } from '@state/matter';
import { MatDialog } from '@angular/material/dialog';
import { NavigationState } from '@state/navigation/navigation.state';
import { BusinessFeatureFlagSelectors, BusinessState } from '@state/business';
import { select, Select } from '@ngxs/store';
import { combineLatest, Observable } from 'rxjs';
import { PAGE } from '@state/navigation/page.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IdvRequestModalComponent } from '../idv-modal/idv-modal.component';
import { TestHooks } from './clients.hooks';
import { UserProfileState } from '@state/user-profile/state';
import { PortalEngineSelectors } from '@domain/portal-engine';

@UntilDestroy()
@Component({
	selector: 'app-parties-clients',
	templateUrl: './clients.component.html',
	standalone: false,
})
export class PartiesClientsComponent implements OnInit {
	testHooks = TestHooks;
	public ICON = ICON;
	public PAGE = PAGE;

	public matterFileTypes = MatterFileType;
	public primaryContact = false;
	public showAddClient = false;
	public buttonText: string;
	public clientType: MatterClientType;
	@SelectSnapshot(SelectedMatter.matterFileType) matterFileType: MatterFileType;

	businessId = select(UserProfileState.getCurrentBusinessId);
	matterId = select(SelectedMatter.id);

	engineData = select(PortalEngineSelectors.$engineData);

	@ViewSelectSnapshot(SelectedMatter.purchasersResideAtProperty)
	purchaserResideInProperty: boolean;
	@ViewSelectSnapshot(MatterClients.get_signorsWithAssociationMapped)
	matterClients: (
		| PersonMatterClientWithAssociations
		| BusinessMatterClientWithAssociations
	)[];

	public client: PersonMatterClient | BusinessMatterClient;
	public fileType: MatterFileType;
	public showTreefort = false;

	@Select(NavigationState.getCurrentPage) currentPage$: Observable<PAGE>;
	@Select(BusinessState.getTreefortConnected)
	isTreefortConnected$: Observable<boolean>;
	@ViewSelectSnapshot(MatterClients.has_idvClients) hasIdvClients: boolean;
	@Select(SelectedMatter.matterFileType)
	matterFileType$: Observable<MatterFileType>;

	isClientIntakeEnabled_ = select(
		BusinessFeatureFlagSelectors.isClientIntakeEnabled,
	);

	constructor(
		private matterDispatch: MatterDispatch,
		private matDialog: MatDialog,
	) {}

	ngOnInit(): void {
		this.buttonText = 'Add Client to Matter';
		this.clientType =
			this.matterFileType === MatterFileType.SALE
				? MatterClientType.SELLER
				: MatterClientType.BUYER;

		combineLatest([
			this.matterFileType$,
			this.currentPage$,
			this.isTreefortConnected$,
		])
			.pipe(untilDestroyed(this))
			.subscribe(([fileType, currentPage, isTreefortConnected]) => {
				this.fileType = fileType;
				if (currentPage === PAGE.MATTER_PARTIES_CLIENTS) {
					if (isTreefortConnected) {
						this.showTreefort = true;
					}
				} else {
					this.showTreefort = false;
				}
			});
	}

	setPurchasersResiding(value) {
		this.matterDispatch.SetPurchaserResidingInProperty(this.matterId(), value);
	}

	trackClient(
		index: number,
		item:
			| PersonMatterClientWithAssociations
			| BusinessMatterClientWithAssociations,
	): string {
		return item.id;
	}

	verify(): void {
		this.openIdvRequestModal();
	}

	private openIdvRequestModal(): void {
		this.matDialog.open(IdvRequestModalComponent, {
			data: { hasCheckboxes: true },
			width: '80vw',
			maxWidth: '1000px',
		});
	}
}
